import React from "react";

const TaskDetailUnarchive = ({ color, strokeWidth = "1.4" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_3791_47730)">
        <path
          d="M13 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5Z"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 4.5V9.5"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 10H4.79313C4.92556 10.0001 5.05255 10.0527 5.14625 10.1462L6.35375 11.3538C6.44745 11.4473 6.57444 11.4999 6.70687 11.5H9.29313C9.42556 11.4999 9.55255 11.4473 9.64625 11.3538L10.8538 10.1462C10.9474 10.0527 11.0744 10.0001 11.2069 10H13.5"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 6.5L8 4.5L10 6.5"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3791_47730">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TaskDetailUnarchive;
